import csv from "fast-csv";
import { EOL } from "os";
import {
  SAVE_RECIPIENT,
  SAVE_RECIPIENT_FAILED,
  SAVE_RECIPIENT_DUPLICATE,
  DELETE_RECIPIENT_SUCCESS,
  DELETE_RECIPIENT_FAILED
} from "./types";
import firebase from "../config/firesbase";

export const saveRecipient = (contact, props) => async dispatch => {
  const user = contact.userId[0];

  try {
    const emailData = await props.firestore
      .collection("recipients")
      .where("userId", "==", user)
      .where("email", "==", contact.email)
      .get();

    if (emailData.empty === false) {
      dispatch({ type: SAVE_RECIPIENT_DUPLICATE });
    } else {
      await props.firestore.collection("recipients").add({
        name: contact.name,
        email: contact.email,
        group: contact.group === undefined ? "none" : contact.group,
        userId: user,
        createdAt: props.firestore.FieldValue.serverTimestamp()
      });

      dispatch({ type: SAVE_RECIPIENT, contact });
    }
  } catch (err) {
    dispatch({ type: SAVE_RECIPIENT_FAILED, err });
  }
};

export const deleteRecipient = (contacts, props) => async dispatch => {
  const db = props.firestore;

  try {
    await contacts.forEach(cont => {
      const ref = db.collection("recipients").doc(cont);
      ref.delete();
    });

    dispatch({ type: DELETE_RECIPIENT_SUCCESS });
  } catch (err) {
    dispatch({ type: DELETE_RECIPIENT_FAILED, err });
  }
};

export const uploadCSVRecipient = (file, props) => async dispatch => {
  const csvFile = file.file.join(EOL);
  const userId = firebase.auth().O;
  const db = props.firestore;

  try {
    await csv
      .parseString(csvFile, { headers: true, ignoreEmpty: true })
      .on("error", error => console.error("Error Message", error))
      .on("data", row => {
        props.firestore
          .collection("recipients")
          .where("userId", "==", userId)
          .where("email", "==", row.email)
          .get()
          .then(snapShot => {
            if (snapShot.empty === false) {
              dispatch({
                type: SAVE_RECIPIENT_DUPLICATE,
                msg: "Some emails already exists"
              });
            } else {
              const contact = {
                name: row.name,
                email: row.email,
                group: file.group === null ? "none" : file.group,
                userId: userId,
                createdAt: props.firestore.FieldValue.serverTimestamp()
              };

              db.collection("recipients")
                .doc()
                .set(contact);
            }
          });
      });
    dispatch({ type: SAVE_RECIPIENT });
  } catch (err) {
    dispatch({ type: SAVE_RECIPIENT_FAILED, err });
  }
};
